import styled from 'styled-components';

export const StyledColumn = styled.section(({ theme, padding }) => ({
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  justifyContent: 'flex-start',
  padding: theme.spacing[padding] || 0,
}));
